module.exports = __webpack_public_path__ + "assets/img/ma.d54e1efa.png";